export default function MainCTA() {
    return (
        <div className="bg-indigo-100 dark:bg-indigo-950 rounded">
            <div className="mx-auto max-w-7xl px-6 py-20 lg:flex lg:items-center lg:justify-between lg:px-8">
                <h2 className="max-w-2xl text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl dark:text-white">
                    Ready to dive in?
                    <br />
                    Start today.
                </h2>
                <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:shrink-0">
                    <a
                        href="/services"
                        className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
                    >
                        {' '}
                        All Services{' '}
                    </a>
                    <a href="/seo-retainer" className="text-sm/6 font-semibold text-gray-900 dark:text-gray-100">
                        All Retainers {" "}
                        <span aria-hidden="true">→</span>
                    </a>
                </div>
            </div>
        </div>
    )
}
